"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'app-users/v1/optin';
var THIRTY_SECONDS_IN_MS = 30000;

var OptInAPI =
/*#__PURE__*/
function () {
  function OptInAPI() {
    (0, _classCallCheck2.default)(this, OptInAPI);
  }

  (0, _createClass2.default)(OptInAPI, null, [{
    key: "getStatus",
    value: function getStatus() {
      return _apiClient.default.get(API_BASE + "/status", {
        timeout: THIRTY_SECONDS_IN_MS
      });
    }
  }]);
  return OptInAPI;
}();

exports.default = OptInAPI;
module.exports = exports.default;